export enum AddPatientMode {
    CREATE = "CREATE",
    LINK = "LINK",
}
